import Icon from 'components/shared/Icon/Icon';

const CheckboxWithChevron = ({ data, node, onStepToggle }) => {
  const isExpanded = node?.expanded;

  const handleChevronClick = (e) => {
    e.stopPropagation();
    node.setExpanded(!isExpanded);
  };

  const handleCheckboxClick = (e) => {
    e.stopPropagation();
    onStepToggle(data.code);
  };

  const hasCheckedSubsteps = data.substeps?.some((sub) => sub.checked);

  return (
    <div className="CheckboxWithChevron flex h-full items-center gap-6 px-2 justify-between">
      <div
        className="flex h-4 w-4 cursor-pointer items-center justify-center flex-shrink-0"
        onClick={handleCheckboxClick}>
        {hasCheckedSubsteps ? (
          <Icon icon="minus-filled" size={20} color="primary" />
        ) : (
          <div className="h-[16px] w-[16px] rounded border border-solid border-[#cdd5d8] bg-white" />
        )}
      </div>
      <div onClick={handleChevronClick} className="cursor-pointer flex-shrink-0">
        <Icon
          icon="chevron-down-linear"
          className={`transition-transform ${isExpanded ? '' : '-rotate-90'}`}
        />
      </div>
    </div>
  );
};

export default CheckboxWithChevron;
